import Form from 'containers/SignupPages/AuthByContractEpargnSms/Form';
import messages from 'containers/SignupPages/AuthUnvalidUserSms/messages';
import { VERIFY_IDENTITY } from 'containers/SignupPages/constants';
import Header from 'containers/SignupPages/Header';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getPhoneSelector } from 'store/user/selectors';

export type AuthBySmsType = {
  intl: IntlShape;
  phone: string;
  onSubmitStep: Function;
  isLoading: boolean;
  setSignupStep: Function;
};

const AuthUnvalidUserSms = (props: AuthBySmsType) => {
  return (
    <React.Fragment>
      <Header
        title={translate({ ...messages.title }, props)}
        subTitle={`${translate({ ...messages.subTitle }, props)} ${
          props.phone
        } :`}
      />
      <Form
        isLoading={props.isLoading}
        onClickPrevious={() => {
          props.setSignupStep(VERIFY_IDENTITY);
        }}
        onSubmitStep={props.onSubmitStep}
      />
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector<any, { phone: string }>({
  phone: getPhoneSelector,
});

export default connect(mapStateToProps)(injectIntl(AuthUnvalidUserSms));
